import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { observer } from 'mobx-react-lite';
import {
  sessionDispatch,
  allSessionProps,
} from '../../selectors/sessionSelectors';
import styles from './questionnaire.module.css';
import { go } from '../../routes/index';
import { isDesktop } from '../../config';
import { useAppointmentStore } from 'store/mobx/mobx';
import styled from 'styled-components';
import { ReactComponent as Tick } from 'svgs/whiteTick2.svg';
import CtaButton from '../../components/CtaButton/index';
import { capitalise } from 'libs/misc';
import { actions as loginActions } from "../../EntryPage/actions/actions";
import { actions as feelingActions } from '../Reason/actions/actions';
import Header from "components/UIContainer/MobileUI/header/index";
import LoadingSpinner from 'components/loadingSpinner/index';

const PageContainer = styled.div`
`
const QuestionContainer = styled.div`
`

const QuestionHeader = styled.h3`
`

const Container = styled.div`
    width: 100%;
    border-radius: 4px;
    color: #FFFFFF;
    background-color: #07A3C8;
    display: flex;
    flex-direction: row;
    font-size: 15px;
    padding: 0.887rem 0.5rem;
    position: relative;
    align-items: center;
    transition: all 0.3s;
    cursor: pointer;
    min-height: 40px;
    max-width: 440px;
`
const Placeholder = styled.div`
    width: 17px;
    background-color: transparent;
    margin: 0rem 0.29rem;
`

const NotUser = styled.div`
`

const Questionnaire = observer(
  ({
    token,
    profile,
    updateSession,
    practice,
    sessionDetails,
    logout,
    service,
    symptoms,
    SymptomsObj,
  }) => {

  const { id, questionId } = useParams();
  const history = useHistory();
  const store = useAppointmentStore();

  const serviceId = store.getSelectedService().Id;

  const firstName = profile.FirstName;

  const [loading, setLoading] = useState(false);
  const currentQuestionIndex = parseInt(questionId, 10) - 1; // Extract the questionId from the URL
  const [answerSelectedIndex, setAnswerSelectedIndex] = useState(-1);
  const [selectedAnswerIds, setSelectedAnswerIds] = useState([]);
  const questionsData = store.ServiceQuestionnaire.QuestionnaireQuestions;

  if (currentQuestionIndex < 0 || currentQuestionIndex >= questionsData.length) {
     // If no questions, continue booking appointment
     updateSession(
      sessionDetails.SessionId,
      store.getSelectedConsultMethod,
      [],
      store.getPatientNotes(),
      {
        Id: serviceId,
        Name: store.ServiceQuestionnaire.ServiceName,
        Description: store.ServiceQuestionnaire.ServiceName
      },
      practice.UrlName,
      selectedAnswerIds
    );
  }

  const currentQuestion = questionsData[currentQuestionIndex];

  useEffect(() => {
    if (!store.receivedServiceQuestionnaire) store.getServiceQuestionnaire(id, 1);
  },[id, store])

  const handleLogOut = () => {
    logout(token);
    go.loginTriage(id);
  };

  const goBack = () => {
    setSelectedAnswerIds(selectedAnswerIds.slice(0, -1));
    history.goBack();
  }

  const handleAnswerClick = (answerIndex) => {
    if (answerIndex < 0) return;
    setAnswerSelectedIndex(answerIndex);

    const action = currentQuestion.Answers[answerIndex].Action;
    const answerIds = [...selectedAnswerIds, currentQuestion.Answers[answerIndex].AnswerId - 1];

    //actions: 
    // 0 - Proceed
    // 1 - Book
    // 2 - Exit
    if (action === 0) {
      // Next question
      setSelectedAnswerIds([...selectedAnswerIds, currentQuestion.Answers[answerIndex].AnswerId - 1]);  
      history.push(`${currentQuestionIndex + 2}`);
    } else if (action === 1) {
      // Continue booking appointment
      setLoading(true)
      setSelectedAnswerIds([...selectedAnswerIds, currentQuestion.Answers[answerIndex].AnswerId - 1]);  
      updateSession(
        sessionDetails.SessionId,
        store.getSelectedConsultMethod,
        [],
        store.getPatientNotes(),
        {
          Id: serviceId,
          Name: store.ServiceQuestionnaire.ServiceName,
          Description: store.ServiceQuestionnaire.ServiceName
        },
        practice.UrlName,
        answerIds
      );
    } else {
      // Stop booking flow
      setSelectedAnswerIds([]);
      go.dropIn(practice.UrlName, practice);
    }
    setAnswerSelectedIndex(-1);
  };
  
  return (
    <LoadingSpinner
      isFetching={!store.receivedServiceQuestionnaire || loading}
      containerClassName={styles.outerContainer}
      iconClassName={styles.spinner}
      overlayClassName={styles.overlay}
    >    
      <PageContainer className={styles.pageContainer}>
        {!isDesktop() && <Header goBackFn={goBack} headerClassNames={styles.header} showHelp />}
        {currentQuestion && <QuestionHeader className={styles.questionHeader}>{currentQuestion.Description}</QuestionHeader>}
        {currentQuestion && <QuestionContainer className={styles.questionContainer}>
            {currentQuestion.Answers.map((answer, i) => (
              <Container 
                onClick={() => { handleAnswerClick(i); }}
                style={{ margin: isDesktop() ? "0.5rem 0rem" : "0.2rem 0rem", padding: isDesktop() ? "0.5rem" : "0.887rem 0.5rem", backgroundColor: "#07A3C8" }}>
                {i === answerSelectedIndex ?
                    <Tick style={{ width: '17px', margin: '0rem 0.5rem', marginLeft: '0rem' }} />
                    :
                    <Placeholder />
                }
                {answer.Description}
            </Container>
            ))}
        </QuestionContainer>}
        <NotUser className={styles.notUser}>
          <div className={styles.logoutText} onClick={handleLogOut}>
            <div className={styles.notUserText}>{`Not ${capitalise(firstName)}?`}</div>
            <div>Log out</div>
          </div>
        </NotUser>
      </PageContainer>
    </LoadingSpinner>
  );
})

const mapStateToProps = state => ({
  token: state.loginReducer.token,
  profile: state.profileReducer.profile,
  practice: state.practiceProfileReducer.profile,
  service: state.service,
  symptoms: state.symptoms,
  SymptomsObj: state.feelingPageReducer.Symptoms,
  sessionDetails: state.checkEnrollmentReducer.session,
});

const mapDispatchToProps = dispatch => ({
  createSession: sessionDispatch(dispatch)(allSessionProps),
  getConsultMethods: bindActionCreators(
    dispatch,
  ),
  updateSession: bindActionCreators(feelingActions.updateSession, dispatch),
  logout: bindActionCreators(loginActions.logout, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Questionnaire);

